import { useSelector } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material';

//export const primaryColor = '#3D42BC';
//export const primaryColor = '#4d7fff'; // captura blue
export const secondaryColor = '#f3f3f8'; // captura grey
//export const secondaryColor = '#FF6662';
//export const primaryColor = '#000';
export const primaryColor = '#f0efe9'; // captura brown
//export const secondaryColor = '#fff';
export const darkModeBackgroundColor = '#181d1f';
export const darkModeToolbarColor = '#222628';

const standardTheme = {
  palette: {
    primary: {
      main: primaryColor
    },
    secondary: {
      main: secondaryColor
    },
    black: {
      main: '#000'
    }
  },
  typography: {
    fontFamily: 'InstrumentSans,Arial,sans-serif !important',
    h1: {
      fontSize: '2rem'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
	root: {
	  transition: 'none',
	  boxShadow: 'none !important',
	  '&:hover': {
	    backgroundColor: '#dcdce3'
	  },
	  '&.pressed': {
	    backgroundColor: '#dcdce3'
	  }
	}
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#333'
          }
        }
      }
    }
  }
}

const darkModeTheme = {
  palette: {
    mode: 'dark',
    background: {
      paper: darkModeBackgroundColor,
      default: darkModeBackgroundColor,
      toolbar: darkModeToolbarColor
    }
  },
  typography: {
    h1: {
      fontSize: '2rem',
      color: '#fff'
    }
  }
}

const Theme = props => {
  const {
    children
  } = props;

  const account = useSelector(state => state.portalReducer.account);
  const darkMode = useSelector(state => state.portalReducer.darkMode);

  let theme = createTheme(darkMode ? darkModeTheme : standardTheme);

  // disabled after rebrand
  //if (account?.primary_color) {
  //  theme.palette ||= {};
  //  theme.palette.primary ||= {};
  //  theme.palette.primary.main = account.primary_color;
  //}

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default Theme;
